import { render, staticRenderFns } from "./ReporteContratos.vue?vue&type=template&id=2676e1a9"
import script from "./ReporteContratos.vue?vue&type=script&lang=js"
export * from "./ReporteContratos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports